import { Icon, IconName } from '@shared/components/Icon';
import { Text, TextSize } from '@shared/components/Text';
import { View, ViewProps } from '@shared/components/View';
import styles from './MenuNote.module.css';

interface MenuNoteProps extends ViewProps {
  textSize?: TextSize;
  icon?: IconName | false;
  /** Icon size in grid units. */
  iconGridSize?: number;
}

export function MenuNote({
  children,
  textSize = 'body2',
  icon = 'info-outline',
  iconGridSize = 2.5,
  className,
  ...rest
}: MenuNoteProps) {
  return (
    <View row className={[styles.menuNote, className]} role="note" {...rest}>
      {icon && (
        <View marginLeft={-0.5} data-slot="icon">
          <Icon name={icon} gridSize={iconGridSize} />
        </View>
      )}
      <View flex>
        <Text size={textSize} pretty>
          {children}
        </Text>
      </View>
    </View>
  );
}
